import React, { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

// styles
import { Wrapper, Inner, NavItem } from './styles';

import { findLocationBreadcrumbs } from '../../../utils/findLocationBreadcrumbs';

interface IState {
  name: string;
  slug: string;
}

interface IProps {
  lastItem?: string;
  light?: boolean;
}

export function Breadcrumbs({ lastItem, light }: IProps) {
  const [breadcrumbs, setBreadcrumbs] = useState<Array<IState> | null>(null);

  // locales hook
  const { t } = useTranslation();

  // location hook
  const location = useLocation();

  useEffect(() => {
    if (location.pathname) {
      const findedBreadcrumbs = findLocationBreadcrumbs(
        location.pathname,
        lastItem,
      );

      setBreadcrumbs(findedBreadcrumbs);
    }
  }, [location]);

  const breadcrumbsIsActive =
    location.pathname !== '/' &&
    !location.pathname.includes('/auth') &&
    breadcrumbs &&
    breadcrumbs.length > 1;

  return breadcrumbsIsActive ? (
    <Wrapper>
      <Inner>
        {breadcrumbs &&
          breadcrumbs.map((item, ind) => (
            <>
              {ind === 0 ? (
                <NavItem key={ind} to={item.slug} light={light ? 1 : 0}>
                  {lastItem && ind + 1 === breadcrumbs.length
                    ? ' ' + lastItem
                    : ' ' + t(translations.nav[item.name])}
                  {ind + 1 !== breadcrumbs.length && ' / '}
                </NavItem>
              ) : (
                <NavItem key={ind} to={item.slug} light={light ? 1 : 0}>
                  {lastItem && ind + 1 === breadcrumbs.length
                    ? ' ' + lastItem
                    : ' ' + t(translations.nav[item.name])}
                  {ind + 1 !== breadcrumbs.length && ' / '}
                </NavItem>
              )}
            </>
          ))}
      </Inner>
    </Wrapper>
  ) : (
    <></>
  );
}

export default Breadcrumbs;
